#import "../fragments/webcast-fragment.graphql"

fragment CTABanner on CTABanner {
    key
    ctaType
    title
    subtitle
    registrationUrl
    dismissSettingName
    demioEvent {
        ...Webcast
    }
    upcomingEvents {
        ...Webcast
    }
}
